var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"image-preview-page",on:{"click":function($event){return _vm.toggleShow()}}},[_c('span',[_c('img',{staticClass:"image-employee",attrs:{"src":_vm.imagePath}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }